import axios from 'axios';

// 환경변수에서 API URL 가져오기 (기본값 설정)
const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://127.0.0.1:8000';

// URL이 http://로 시작하는지 확인
const ensureProtocol = (url: string) => {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
};

export const apiClient = axios.create({
  baseURL: ensureProtocol(API_BASE_URL),
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// 응답 인터셉터 - 공통 에러 처리
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // 서버가 응답을 반환한 경우
      console.error('API Error: ', error.response.data);
      return Promise.reject(error.response.data);
    } else if (error.request) {
      // 요청은 보냈지만 응답을 받지 못한 경우
      console.error('No response from server');
      return Promise.reject({
        success: false,
        message: '서버와 연결할 수 없습니다.',
      });
    } else {
      // 요청 설정 중 에러 발생
      console.error('Request setup error: ', error.message);
      return Promise.reject({
        success: false,
        message: '요청 중 오류가 발생했습니다.',
      });
    }
  },
);

// 디버깅용 - 개발 환경에서만 API URL 로그 출력
if (process.env.NODE_ENV === 'development') {
  console.log('API Base URL:', ensureProtocol(API_BASE_URL));
  console.log('Full API URL Example:', `${ensureProtocol(API_BASE_URL)}/api/v1/visitor/create`);
}
